var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      class: _vm.$conf.sidebar.enabled ? "" : "on-edge",
      attrs: { id: "wmsselector" },
    },
    [
      _c(
        "button",
        {
          staticClass: "button is-light wms-b",
          attrs: {
            type: "button",
            disabled: this.$store.getters["isUiDisabled"],
          },
          on: { click: _vm.copyWmsLink },
        },
        [
          _vm._v(
            "\n      " + _vm._s(this.$store.state.wmsRequest) + "\n      "
          ),
          _c("b-icon", { attrs: { id: "copyicon", icon: "content-copy" } }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }